import { TableCell, TableRow } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ArtworkCol from 'commons/ArtworkCol';
import Text from 'commons/Text';
import { getLabelForOption } from 'configs/Constant';
import Routes from 'utils/Route';
import { formatCurrency } from 'utils/utils';

import DisplayData from '../../../Common/DisplayData';
import TableArtworkCollectorAction from '../../../Common/TableArtworkCollectorAction';
import useStyles from './styles';

const ArtworkRow = ({ artwork }) => {
  const classes = useStyles();
  const language = useSelector((state) => state?.language?.currentLanguage);
  const navigate = useNavigate();
  const { artist, artist_artwork, certificate } = artwork || {};

  const priceFormat = formatCurrency(artwork?.price);

  const artistName = artist?.name || artist_artwork?.artist_name || 'N/A';
  const isPlatformArtist = !!artist;
  const canNavigateToArtist = isPlatformArtist && certificate;

  const getSizeData = (size) => {
    const { height, width, depth } = size || {};

    if (!height || !width) return null;

    return `${height} x ${width}${depth ? ` x ${depth}` : ''} cm`;
  };

  const sizeData = getSizeData(artwork?.size);

  const handleNavigateToGallery = () => {
    if (canNavigateToArtist) {
      navigate(Routes.GalleryDetail(artist.uuid));
    }
  };

  const handleNavigateArtworkDetail = () => {
    navigate(Routes.ArtworkDetail(artwork?.uuid));
  };

  return (
    <TableRow>
      <TableCell onClick={handleNavigateArtworkDetail}>
        <ArtworkCol
          uuid={artwork?.uuid}
          image={artwork?.images[0]}
          title={artwork?.title}
          isLink
        />
      </TableCell>
      {/* Ẩn cột visibility
      <DisplayData value={artwork?.is_public ? t('public') : t('private')} />
      */}
      <TableCell>
        <Text
          type="sm"
          clickAble={canNavigateToArtist}
          onClick={handleNavigateToGallery}
          className={clsx(classes.textArtist, {
            [classes.link]: canNavigateToArtist,
          })}
        >
          {artistName}
        </Text>
      </TableCell>
      <DisplayData value={getLabelForOption(artwork?.medium, language)} />
      <DisplayData value={artwork?.year_created || artwork?.period_created} />
      <DisplayData value={sizeData} />
      <DisplayData value={priceFormat ? `${priceFormat} ${artwork?.currency}` : null} />
      <DisplayData />
      <DisplayData value={artwork?.inventory_code} />
      <DisplayData value={artwork?.location?.location} />
      <DisplayData value={artwork?.status?.value} />
      <TableArtworkCollectorAction artwork={artwork} />
    </TableRow>
  );
};

export default ArtworkRow;
